<template>
  <v-tooltip
    top
    max-width="400"
  >
    <template v-slot:activator="{ on: onTooltip }">
      <div v-on="{ ...onTooltip }">
        <v-text-field
          v-model="value.pesquisa"
          :dense="dense"
          append-icon="search"
          label="Pesquisar"
          placeholder="Digite para pesquisar..."
          single-line
          clearable
          hide-details
        />
      </div>
    </template>
    <span>Digite para pesquisar</span>
  </v-tooltip>
</template>

<script>
export default {
  name: 'AppSearch',

  props: {
    value: {
      type: Object,
      default: () => ({
        pesquisa: '',
      }),
      required: true,
    },
    dense: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
};
</script>
